import { useRef } from "react";
import { InputAdornment, TextField, Typography } from "@mui/material";
import type { ChangeEvent } from "react";

type Props = Readonly<{
	file: File | null;
	onChange: (file: File | null) => void;
}>;

const formatFileSize = (sizeInBytes: number): string => {
	if (sizeInBytes < 1024) return `${sizeInBytes} bytes`;
	if (sizeInBytes < 1024 * 1024) return `${(sizeInBytes / 1024).toFixed(2)} KB`;
	return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
};

const MuiFileInput = ({ file, onChange }: Props) => {
	const inputRef = useRef<HTMLInputElement>(null);

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const uploadedFile = event.target.files?.[0] ?? null;
		onChange(uploadedFile);
	};

	const triggerFileSelect = () => {
		inputRef.current?.click();
	};

	return (
		<>
			<input
				ref={inputRef}
				type="file"
				accept=".json,application/json"
				style={{ display: "none" }}
				onChange={handleChange}
			/>
			<TextField
				variant="standard"
				fullWidth={true}
				value={file ? file.name : ""}
				onClick={triggerFileSelect}
				slotProps={{
					input: {
						readOnly: true,
						startAdornment: (<InputAdornment position="start" />),
						endAdornment: file ? (
							<InputAdornment position="end">
								<Typography variant="caption" sx={{ fontWeight: 400 }}>
									{formatFileSize(file.size)}
								</Typography>
							</InputAdornment>
						) : null,
					},
				}}
			/>
		</>
	);
};

export default MuiFileInput;
